import { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import InputText from "../inputText/InputText";
import CustomButton from "../customButton/CustomButton";
import { Link, useNavigate } from "react-router-dom";
import ReactNotifications, { showApiErrors } from "../reactNotifications/ReactNotifications";
import * as utilConstants from "../../../utils/constants/utilsConstants";
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";
import SignupLeftSideCard from "../cards/SignupLeftSideCard";
import Stepper from "./Stepper";
import logo from "../../../assets/images/logo.png"
import { Country, State } from "country-state-city";
import Context from "../../../context/Context";
import { scrollToError } from "../../../utils/helper";

const AuthForm = ({
    formType,
    onSubmit,
    initialValues,
    validationFunc,
    successRedirectPath,
    customLinks,
    buttonLabel,
    loadingLabel,
    customFields,
    isCustomSubmitFunction = false,
    customFunctionErrors = {},
    stepper = false,
    step = 1,
    children,
    title = "Admin Login",
    subTitle = "Enter your admin credentials to access the dashboard",
    mdSize
}) => {
    const [formValues, setFormValues] = useState(initialValues);
    const [errors, setErrors] = useState(
        isCustomSubmitFunction ? customFunctionErrors : {}
    );
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [mobileCode, setMobileCode] = useState("+1");
    const [states, setStates] = useState([]);
    const { refreshUser } = useContext(Context);
    const businessRoles = ['Company Head', 'Team Head', 'Member'];

    const navigate = useNavigate();

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues({
            ...formValues,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    useEffect(() => {
        if (isCustomSubmitFunction) {
            setErrors(customFunctionErrors);
        }
    }, [customFunctionErrors, isCustomSubmitFunction]);

    useEffect(() => {
        if (formValues?.country_region) {
            let countryName = formValues.country_region;

            if (countryName === "United States of America") {
                countryName = "United States";
            }

            const country = Country.getAllCountries().find(
                (c) => c.name === countryName
            );

            if (country) {
                const statesList = State.getStatesOfCountry(country.isoCode);
                setStates(statesList);
            } else {
                setStates([]);
            }
        }
    }, [formValues.country_region]);



    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const updatedValues = {
            ...formValues,
            phone_number: formValues?.phone_number?.length > 9 ? `${mobileCode}${formValues?.phone_number}` : formValues?.phone_number,
        };

        const payload = formType === "New User Profile" ? updatedValues : formValues;
        const { isValid, errors } = validationFunc(payload);
        if (isValid) {
            onSubmit(payload, (res) => {
                setLoading(false);
                setErrors({});
                if (res?.access) {
                    const loginMessage = res?.access
                        ? `${res?.role} logged in successfully`
                        : res?.message || res?.message;

                    ReactNotifications(
                        loginMessage,
                        utilConstants.sucessState200
                    );
                    if (res?.access) {
                        const decoded = jwtDecode(res?.access);
                        const expirationTime = new Date(decoded?.exp * 1000);
                        Cookies.set('adminToken', res?.access, {
                            expires: expirationTime,
                            path: '/'
                        });
                        refreshUser();
                        localStorage.setItem('role', res?.role);
                        if (res?.role === 'superuser') return navigate('/admin/dashboard');
                    } else {
                        navigate(successRedirectPath);
                    }

                } else {
                    if (res?.data?.status === true || res?.status === 200) {
                        ReactNotifications(
                            res?.data?.message || res?.message,
                            utilConstants.sucessState200
                        );
                    } else {
                        showApiErrors(res);
                    }
                }
            });
        } else {

            setErrors(errors);
            scrollToError(errors);
            setLoading(false);
        }
    };

    return (
        <div className="min-vh-100">
            <Container fluid>
                <Row className="min-vh-100">
                    <Col
                        xs={12}
                        md={12}
                        className="d-flex align-items-center justify-content-center"
                    >

                        <div className="w-100" style={{ maxWidth: "600px" }}>
                            <div className="flex items-center mb-6 block">
                                <img
                                    className="img-thumbnail !border-none !max-w-[170px] md:!max-w-[180px]"
                                    src={logo}
                                    alt="logo"
                                />
                            </div>
                            {stepper && <div className="flex items-center mb-8 mt-2">
                                <Stepper currentStep={step} />
                            </div>}

                            <h3 className="text-2xl md:text-3xl lg:text-4xl font-medium mb-2">
                                {title}
                            </h3>
                            <p className="text-muted text-sm md:text-base mb-8">
                                {subTitle}
                            </p>
                            <Form
                                noValidate
                                className="shadow-lg shadow-gray-500/50 !rounded-none bg-white"
                                onSubmit={isCustomSubmitFunction ? (e) => onSubmit(e, formValues, mobileCode) : handleSubmit}
                            >
                                <div className="px-4 pb-4 ">
                                    <Row className=" max-h-[60vh] overflow-y-auto">
                                        {customFields?.map((field, index) => {
                                            const isTermsField = field?.name?.toLowerCase().includes("terms");
                                            return (
                                                <Col key={index} md={isTermsField ? 12 : mdSize ? mdSize : customFields.length > 5 ? 6 : 12} className="position-relative">
                                                    <div className="position-relative">
                                                        {field?.type === 'checkbox' ? (
                                                            <div className={`mt-4 d-flex align-items-center  ${isTermsField ? 'w-100 black-checkbox' : ''}`}>
                                                                <Form.Check
                                                                    label={field?.label}
                                                                    name={field?.name}
                                                                    type={field.type}
                                                                    id={`${field.type}-${index}`}
                                                                    checked={formValues[field.name]}
                                                                    onChange={onChange}
                                                                    isInvalid={errors[field.name]}
                                                                    className={`custom-dark-checkbox ${isTermsField ? 'w-100' : ''}`}
                                                                />
                                                            </div>
                                                        ) : field?.type !== 'select' ? (
                                                            <InputText
                                                                type={
                                                                    (field.name === "password" && showPassword) ||
                                                                        (field.name === "confirm_password" && showConfirmPassword)
                                                                        ? "text"
                                                                        : field.type
                                                                }
                                                                controlId={field.name}
                                                                name={field.name}
                                                                value={formValues[field.name]}
                                                                error={errors[field.name]}
                                                                placeholder={
                                                                    field.placeholder + (field.required ? "*" : "")
                                                                }
                                                                onChange={onChange}
                                                                mobileCode={mobileCode}
                                                                setMobileCode={setMobileCode}
                                                                id={field?.id}
                                                            />
                                                        ) : (
                                                            <>
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name={field.name}
                                                                    placeholder={
                                                                        field.placeholder
                                                                            ? field.placeholder + (field.required ? "*" : "")
                                                                            : "Select" + (field.required ? "*" : "")
                                                                    }
                                                                    value={formValues[field?.name]}
                                                                    isInvalid={errors[field.name]}
                                                                    onChange={onChange}
                                                                    className="mt-4 custom-select"
                                                                >
                                                                    {field.name === "state"
                                                                        ? states.map((state) => (
                                                                            <option key={state.isoCode} value={state.name}>
                                                                                {state.name}
                                                                            </option>
                                                                        ))
                                                                        : field.options &&
                                                                        field.options.map((option, idx) => (
                                                                            <option key={idx} value={option.value}>
                                                                                {option.label}
                                                                            </option>
                                                                        ))}
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errors[field.name]}
                                                                </Form.Control.Feedback>
                                                            </>
                                                        )}

                                                        {field.name === "password" && (
                                                            <div
                                                                className="position-absolute"
                                                                style={{
                                                                    top: errors?.password
                                                                        ? errors?.password.length > 30 ? '34%' : '50%'
                                                                        : "70%",
                                                                    right: errors?.password
                                                                        ? "37px"
                                                                        : "10px",
                                                                    transform: "translateY(-50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() =>
                                                                    setShowPassword(!showPassword)
                                                                }
                                                            >
                                                                {showPassword ? (
                                                                    <FaEyeSlash />
                                                                ) : (
                                                                    <FaEye />
                                                                )}
                                                            </div>
                                                        )}
                                                        {field.name === "confirm_password" && (
                                                            <div
                                                                className="position-absolute"
                                                                style={{
                                                                    top: errors?.confirm_password
                                                                        ? "50%"
                                                                        : "70%",
                                                                    right: errors?.confirm_password
                                                                        ? "37px"
                                                                        : "10px",
                                                                    transform: "translateY(-50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() =>
                                                                    setShowConfirmPassword(
                                                                        !showConfirmPassword
                                                                    )
                                                                }
                                                            >
                                                                {showConfirmPassword ? (
                                                                    <FaEyeSlash />
                                                                ) : (
                                                                    <FaEye />
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                            )
                                        })}
                                    </Row>

                                    <CustomButton className="w-100 login-btn mt-3 !bg-[#AEF468] !text-black !font-bold" type="submit">
                                        {!loading ? buttonLabel : loadingLabel}
                                    </CustomButton>

                                    <div className="flex flex-col sm:flex-row gap-2 w-full">
                                        {customLinks &&
                                            customLinks.map((link, index) => (
                                                <Link key={index} to={link.to} className="w-full">
                                                    <CustomButton
                                                        variant={link?.variant}
                                                        className={`${link?.class ? link?.class : "w-full mt-3"} login-btn`}
                                                        type="button"
                                                    >
                                                        <span className="text-white text-decoration-none">
                                                            {link?.label}
                                                        </span>
                                                    </CustomButton>
                                                </Link>
                                            ))}
                                    </div>

                                </div>
                                {children && <div>{children}</div>}
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AuthForm;
